import {GameStateEnums} from '../../../../shared/GameEnums.ts'
import {type UIGameMechanic} from '../../../shared/scripts/ui_game/UIGameEventController.ts'
import {type UIGameManager} from '../../../shared/scripts/ui_game/UIGameManager.ts'
import {UIMDeviceHandler} from '../ui_html/UIMDeviceHandler.ts'

export class UIMGameReviewController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
    }
    onEvent(data: any, eventType: GameStateEnums.UIGameEventEnums) {
        switch(eventType) {
            case GameStateEnums.UIGameEventEnums.FeedbackFormSubmitted: this.onFeedbackFormSubmitted(data)
                break
            default: break
        }
    }

    // eslint-disable-next-line class-methods-use-this
    private onFeedbackFormSubmitted(rating: number): void {
        if(rating <= 4) return
        UIMDeviceHandler.requestReview()
    }
}
